/** MY Register role position codes (B30) — L_CONTACT_BRANCH_MAP.POSITION_CD */
export const MY_REGISTER_POSITION_CD = {
    DIRECTOR: 'B30027',
    SECRETARY: 'B30033',
    MANAGER: 'B30035',
    MEMBER: 'B30034',
    BENEFICIAL_OWNER: 'B30046',
    AUDITOR: 'B30025',
    TAX_AGENT: 'B30045',
} as const;

/** Global Contact category */
export const MY_REGISTER_CATEGORY_CORPORATE = 'B09001';
export const MY_REGISTER_CATEGORY_INDIVIDUAL = 'B09002';

export function isCorporateRegisterCategory(categoryCd: unknown): boolean {
    return String(categoryCd ?? '').trim().toUpperCase() === MY_REGISTER_CATEGORY_CORPORATE;
}

/** Auditor / Member·BO 법인 — L_CONTACT_BRANCH 저장 (location GUID + B15 country) */
export function shouldUseRegisterCorporateBranchSave(
    categoryCd: unknown,
    positionCd: unknown,
): boolean {
    const pos = String(positionCd ?? '').trim();
    if (pos === MY_REGISTER_POSITION_CD.AUDITOR) return true;
    if (pos === MY_REGISTER_POSITION_CD.TAX_AGENT) return true;
    if (!isCorporateRegisterCategory(categoryCd)) return false;
    return pos === MY_REGISTER_POSITION_CD.MEMBER
        || pos === MY_REGISTER_POSITION_CD.BENEFICIAL_OWNER;
}

/** Register 저장 payload category — jsonData 필드 통합 */
export function resolveRegisterContactCategoryCd(
    jsonData?: Record<string, unknown> | null,
    explicitCategoryCd?: unknown,
): string {
    const explicit = String(explicitCategoryCd ?? '').trim();
    if (explicit) return explicit.toUpperCase();
    const data = jsonData || {};
    // Transfer: TEE_CATEGORY_CD 가 Member(양수인) 정본. CATEGORY_CD 만 보면 개인으로 떨어져 L_CONTACT_ADDRESS 저장됨.
    return String(
        data.TEE_CATEGORY_CD
        ?? data.tee_category_cd
        ?? data.CATEGORY_CD
        ?? data.category_cd
        ?? data.categoryCd
        ?? data.categoryCode
        ?? MY_REGISTER_CATEGORY_INDIVIDUAL,
    ).trim().toUpperCase() || MY_REGISTER_CATEGORY_INDIVIDUAL;
}
